import { render } from "./EnbGift.vue?vue&type=template&id=12e0d230&scoped=true"
import script from "./EnbGift.vue?vue&type=script&lang=js"
export * from "./EnbGift.vue?vue&type=script&lang=js"

import "./EnbGift.vue?vue&type=style&index=0&id=12e0d230&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e0d230"]])

export default __exports__